/**
 * Unified CSV Template for HealthCues
 * Used in both Admin (Workforce) and Client Portal (Census Upload)
 *
 * ALL SUPPORTED COLUMNS:
 * - Name, Employee ID, Email, Department (identification)
 * - Annual Salary, State, Filing Status (required for calculations)
 * - City, Zip (optional — enables jurisdiction-aware min wage + local income tax)
 * - Hire Date, Weekly Hours, Worker Type (eligibility)
 * - Pay Frequency, Employment Type, Annual Hours (optional calculation modifiers)
 * - Ownership %, HCE Flag, Union Member (special eligibility cases)
 */

export const CSV_TEMPLATE = `Name,Employee ID,Email,Department,Annual Salary,State,City,Zip,Filing Status,Hire Date,Weekly Hours,Worker Type,Ownership %,HCE Flag,Union Member,Pay Frequency,Employment Type,Annual Hours
John Smith,EMP001,john.smith@example.com,Operations,31200,CA,San Francisco,94110,Single,03/15/2024,40,W-2,0,No,No,Biweekly,Full-Time,2080
Jane Doe,EMP002,jane.doe@example.com,Sales,45000,TX,Austin,78701,MFJ,11/01/2025,40,W-2,0,No,No,Monthly,Full-Time,2080
Bob Johnson,EMP003,bob.johnson@example.com,Kitchen,22000,NY,New York City,10001,Single,01/10/2026,25,W-2,0,No,No,Weekly,Part-Time,1300
Mike Davis,EMP004,mike.davis@example.com,Delivery,35000,FL,Miami,33101,Single,,35,1099,0,No,No,,,1820
Sue Park,EMP005,sue.park@example.com,Management,165000,CA,San Francisco,94110,MFJ,06/01/2020,40,W-2,15,Yes,No,Monthly,Full-Time,2080
Lisa Chen,EMP006,lisa.chen@example.com,Production,28000,TX,Houston,77002,Single,08/20/2025,30,W-2,0,No,Yes,Biweekly,Part-Time,1560
,,,,,,,,,,,,,,,,,
Instructions:,,,,,,,,,,,,,,,,,
"Name - Employee full name (REQUIRED)",,,,,,,,,,,,,,,,,
"Employee ID - Optional unique employee identifier",,,,,,,,,,,,,,,,,
"Email - Employee email address (REQUIRED for enrollment invitations)",,,,,,,,,,,,,,,,,
"Department - Optional department or cost center",,,,,,,,,,,,,,,,,
"Annual Salary - Gross annual compensation in dollars (REQUIRED)",,,,,,,,,,,,,,,,,
"State - Two-letter state code like CA, TX, NY (REQUIRED)",,,,,,,,,,,,,,,,,
"City - Employee city or county (optional; enables NYC/SF/etc. local-tax precision)",,,,,,,,,,,,,,,,,
"Zip - 5-digit ZIP code (optional; used to resolve jurisdiction when City is blank)",,,,,,,,,,,,,,,,,
"Filing Status - Tax filing status: Single, MFJ (Married Filing Jointly), MFS, HOH, or QSS (REQUIRED)",,,,,,,,,,,,,,,,,
"Hire Date - Date of hire in MM/DD/YYYY, YYYY-MM-DD, or MM-DD-YYYY format (for waiting period eligibility)",,,,,,,,,,,,,,,,,
"Weekly Hours - Average weekly hours worked (for hours-based eligibility, defaults to 40 if blank)",,,,,,,,,,,,,,,,,
"Worker Type - W-2 or 1099 (determines plan eligibility, defaults to W-2 if blank)",,,,,,,,,,,,,,,,,
"Ownership % - Ownership percentage for 2% S-Corp shareholder rules (0-100, defaults to 0)",,,,,,,,,,,,,,,,,
"HCE Flag - Highly Compensated Employee: Yes/No (for non-discrimination testing, auto-calculated if blank)",,,,,,,,,,,,,,,,,
"Union Member - Union/CBA member: Yes/No (determines union eligibility class, defaults to No)",,,,,,,,,,,,,,,,,
"Pay Frequency - Monthly, Semi-Monthly, Biweekly, or Weekly (affects per-paycheck calculations, defaults to Monthly)",,,,,,,,,,,,,,,,,
"Employment Type - Full-Time, Part-Time, Seasonal, or Temporary (for eligibility classification)",,,,,,,,,,,,,,,,,
"Annual Hours - Total work hours per year (calculated from Employment Type if blank)"`;

export const CSV_TEMPLATE_FILENAME = 'healthcues-census-template.csv';
